import React, { useEffect, useState } from 'react'
import * as SeguradoraHttp from '../../../../services/api/https/registration/seguradora.http'
import { connect } from 'react-redux'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { Btn, CustomCheckbox, CustomModal, InputCnpj, InputText } from '../../../../components'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  INIT: 'Adquirindo informações iniciais',
  SAVE: 'Salvando seguradora',
  SUCCESS: 'Seguradora salvo com sucesso',
}

const INITIAL_STATE = {
  seguradora: {
    id: undefined,
    cnpj: '',
    razao_social: '',
    actived: true,
  },
  savedSeguradora: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const SeguradoraModal = ({ show, onModalClose, onModalSave, data, selectedTp, dispatch }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const saveSeguradora = ({ created_at, updated_at, ...seguradora }) => {
    SeguradoraHttp.saveSeguradora(seguradora)
      .then(savedSeguradora =>
        setState(prevState => ({
          ...prevState,
          savedSeguradora: savedSeguradora,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  // Events
  const onBtnSalvarClicked = async () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const onFormContentChange = (name, value) => {
    setState(prevState => {
      prevState.seguradora[name] = value
      return { ...prevState }
    })
  }

  // Helpers
  const fetchInitInfo = seguradora => {
    setState(prevState => ({
      ...prevState,
      seguradora: seguradora ? seguradora : { ...INITIAL_STATE.seguradora },
      loadingMessage: LOAD_MESSAGE.INIT,
    }))
  }

  const resetModal = () => {
    setState({ ...INITIAL_STATE })
  }

  //Hooks
  useEffect(() => {
    if (show) fetchInitInfo(data)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        const formattedSeguradora = {
          ...state.seguradora,
          tp_id: selectedTp,
        }
        saveSeguradora(formattedSeguradora)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedSeguradora)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Seguradora"
      isVisible={show}
      onClose={() => {
        resetModal()
        onModalClose()
      }}
      width={800}
    >
      <form className="p-grid">
        <div className="p-col-4">
          <InputCnpj
            label="CNPJ:*"
            value={state.seguradora.cnpj}
            onChange={({ value }) => onFormContentChange('cnpj', value)}
          />
        </div>
        <div className="p-col-8">
          <InputText
            label="Razão Social:*"
            value={state.seguradora.razao_social}
            onChange={value => onFormContentChange('razao_social', value.toUpperCase())}
          />
        </div>

        <div className="p-col-12">
          <CustomCheckbox
            checked={state.seguradora.actived}
            onChange={value => onFormContentChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(SeguradoraModal)
